import {
  CarOutlined,
  GlobalOutlined,
  HeartOutlined,
  HomeOutlined,
  ShopOutlined,
  UserOutlined,
  WalletOutlined
} from '@ant-design/icons';
import { message } from 'antd';
import imageCompression from 'browser-image-compression';
import heic2any from 'heic2any';
import * as moment from 'moment';
import Payment from 'payment';
import React from 'react';
import { formatValue } from 'react-currency-input-field';
import Geocode from 'react-geocode';
import { CONFIG, USER_STATES } from './constants';
import { instanceRef } from './utils/axios';
import { formatoMonedaGenerico } from './utils/converters';

export const DEFAULT_PAGE_SIZE = 20;

export const ESTADOS_INSPECCION = {
  PENDIENTE: 'Pendiente',
  INICIADA: 'Iniciada',
  FOTOS_SUBIDAS: 'Fotos subidas',
  AMPLIACION_PENDIENTE: 'Ampliacion pendiente',
  FINALIZADA: 'Finalizada'
};

export const ESTADOS_SINIESTRO = {
  DENUNCIA: 'Denuncia',
  SINIESTRO: 'Siniestro'
};

export const RESULTADOS_SINIESTRO = {
  APROBADO: 'Aprobado',
  RECHAZADO: 'Rechazado',
  ORDENES: 'Ordenes',
  FINIQUITADO: 'Finiquitado'
};

export const ETAPAS_SINIESTRO = {
  PENDIENTE: 'Pendiente',
  PENDIENTE_FIRMA: 'Pendiente de Firma',
  FIRMADA: 'Firmada',
  FOTOS_SUBIDAS: 'Fotos subidas',
  AMPLIACION_PENDIENTE: 'Ampliacion pendiente',
  AMPLIACION_FINALIZADA: 'Ampliacion finalizadda',
  FINALIZADA: 'Finalizada',
  INICIADA: 'Iniciada'
};

export const TIPOS_VEHICULO_MASIVA = {
  AUTOMOVIL: 'Automovil',
  MOTOCICLETA: 'Motocicleta',
  BICICLETA: 'Bicicleta'
};

export const ESTADOS_AUTORIZACION = {
  PENDIENTE: 'Pendiente',
  APROBADO: 'Aprobado',
  RECHAZADO: 'Rechazado',
  COBERTURAS_EXCLUIDAS: 'Coberturas Excluídas',
  MODIFICADO: 'Modificado'
};

export const ESTADOS_AUTORIZACION_FLUJO = {
  PENDIENTE: 'Pendiente',
  APROBADO: 'Aprobado',
  RECHAZADO: 'Rechazado',
  ARCHIVADO: 'Archivado',
  APROBADO_PARCIALMENTE: 'Aprobado Parcialmente'
};

export const ESTADOS_GENERAL_AUTORIZACION_FLUJO = {
  EMPRESA: 'Empresa',
  ASEGURADORA: 'Aseguradora'
};

export const ESTADOS_AUTORIZACION_DETALLE = {
  APROBADO: 'Aprobado',
  RECHAZADO: 'Rechazado',
  ARCHIVADO: 'Archivado',
  VERIFICADO: 'Verificado'
};

export const TIPO_VALIDACION_AUTORIZACION = {
  DESCUENTO: 'Descuento',
  CUESTIONARIO: 'Cuestionario',
  MONTO: 'Monto',
  RETROACTIVIDAD: 'Retroactividad',
  ZONA: 'Zona',
  VEHICULO: 'Vehículo',
  VIGENCIA: 'Vigencia',
  MODIFICACION: 'Modificación',
  MONTO_ITEM: 'Monto ítem',
  DATOS: 'Datos',
  CUMULO: 'Cúmulo',
  PLAN: 'Plan'
};
const ESTADOS_VERIFICACION_AUTORIZACION = {
  INICIAL: 'INICIAL',
  EJECUTIVO: 'EJECUTIVO',
  ADMIN_SUCURSAL: 'ADMIN_SUCURSAL',
  ADMIN_EMPRESA: 'ADMIN_EMPRESA',
  EJECUTIVO_ASEGURADORA: 'EJECUTIVO_ASEGURADORA',
  ADMIN_SUCURSAL_ASEGURADORA: 'ADMIN_SUCURSAL_ASEGURADORA',
  ADMIN_ASEGURADORA: 'ADMIN_ASEGURADORA'
};

export const ORDEN_ESTADOS_VERIFICACION_AUTORIZACION = {
  EMPRESA: [
    ESTADOS_VERIFICACION_AUTORIZACION.INICIAL,
    ESTADOS_VERIFICACION_AUTORIZACION.EJECUTIVO,
    ESTADOS_VERIFICACION_AUTORIZACION.ADMIN_SUCURSAL,
    ESTADOS_VERIFICACION_AUTORIZACION.ADMIN_EMPRESA
  ],
  ASEGURADORA: [
    ESTADOS_VERIFICACION_AUTORIZACION.INICIAL, // No se usa todavía
    ESTADOS_VERIFICACION_AUTORIZACION.EJECUTIVO_ASEGURADORA,
    ESTADOS_VERIFICACION_AUTORIZACION.ADMIN_SUCURSAL_ASEGURADORA,
    ESTADOS_VERIFICACION_AUTORIZACION.ADMIN_ASEGURADORA
  ]
};

export const ESTADOS_COTIZACION = {
  PENDIENTE: 'Pendiente',
  ENVIADO: 'Enviado',
  RECHAZADO: 'Rechazado'
};
export const ESTADOS_ERROR_TRANSACCIONES_BANCARD = {
  FONDOS_INSUFICIENTES: 'FONDOS_INSUFICIENTES',
  TARJETA_INHABILITADA: 'TARJETA_INHABILITADA',
  TRANSACCION_INVALIDA: 'TRANSACCION_INVALIDA',
  TARJETA_INVALIDA: 'TARJETA_INVALIDA',
  ERROR: 'ERROR'
};

export const LABEL_ESTADOS_ERROR_TRANSACCIONES_BANCARD = {
  FONDOS_INSUFICIENTES: 'Fondos insuficientes',
  TARJETA_INHABILITADA: 'Tarjeta inhabilitada',
  TRANSACCION_INVALIDA: 'Transacción inválida',
  TARJETA_INVALIDA: 'Tarjeta inválida',
  ERROR: 'Error al intentar pagar la cuota'
};

export const colores = [
  { descripcion: 'OTRO' },
  { descripcion: 'AMARILLO' },
  { descripcion: 'AZUL CLARO' },
  { descripcion: 'AZUL OSCURO' },
  { descripcion: 'AZUL' },
  { descripcion: 'BEIGE' },
  { descripcion: 'BLANCO' },
  { descripcion: 'CELESTE' },
  { descripcion: 'CHAMPAGNE' },
  { descripcion: 'CHAMPAN' },
  { descripcion: 'COBRE' },
  { descripcion: 'CREMA' },
  { descripcion: 'GRANATE' },
  { descripcion: 'GRIS CLARO' },
  { descripcion: 'GRIS OSCURO' },
  { descripcion: 'GRIS PLATINO' },
  { descripcion: 'GRIS' },
  { descripcion: 'MARRON' },
  { descripcion: 'NARANJA' },
  { descripcion: 'NEGRO' },
  { descripcion: 'PLATA' },
  { descripcion: 'PLATEADO' },
  { descripcion: 'ROJO' },
  { descripcion: 'ROSA' },
  { descripcion: 'VERDE' }
];

export const prefijos3Digitos = [
  '991',
  '992',
  '993',
  '994',
  '995',
  '996',
  '997',
  '981',
  '982',
  '983',
  '984',
  '985',
  '986',
  '987',
  '961',
  '962',
  '971',
  '972',
  '973',
  '974',
  '975',
  '976',
  '977'
];

function clearNumber(value = '') {
  return value.replace(/\D+/g, '');
}

export function formatCreditCardNumber(value) {
  if (!value) {
    return value;
  }

  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;

  switch (issuer) {
    case 'amex':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 15)}`;
      break;
    case 'dinersclub':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 14)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      break;
  }

  return nextValue.trim();
}

export function formatCVC(value, prevValue, allValues = {}) {
  const clearValue = clearNumber(value);
  let maxLength = 4;

  if (allValues.number) {
    const issuer = Payment.fns.cardType(allValues.number);
    maxLength = issuer === 'amex' ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(value) {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 5) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 6)}`;
  }

  return clearValue;
}

export function formatFormData(data) {
  return Object.keys(data).map((d) => `${d}: ${data[d]}`);
}

export const errorHandler = (error, mensaje) => {
  if (error?.response?.data?.message) {
    if (error.response.data.message.constructor === Object) {
      if (Object.keys(error.response.data.message).length === 0) {
        message.error('Intente más tarde');
      } else {
        message.error(JSON.stringify(error.response.data.message));
      }
    } else {
      message.error(error.response.data.message);
    }
  } else if (error && error.request) {
    message.error('Error de conexión. Intente más tarde');
  } else if (error && error.message) {
    message.error(error.message);
  } else {
    message.error(mensaje || 'Error al procesar');
  }
};

export const formatCelular = (celular) => {
  if (celular) {
    return celular.replace(/\s|-|_|\(|\)/g, '');
  }
  return celular;
};

export const parseCelular = (celular) => {
  if (celular === 'A Confirmar') {
    return '';
  }
  if (celular) {
    const codigoStart = 4;
    const codigoEnd = 7;
    const codigo = celular.substring(codigoStart, codigoEnd);
    const numeroPre = celular.substring(7, 10);
    const numeroPos = celular.substring(10, 13);

    return `(${codigo}) ${numeroPre}-${numeroPos}`;
  }
  return celular;
};

// { label: 'Fraccionado (10 Pagos)', value: 'FRACCIONADO_10' },
export const listaFormaPago = [
  { label: 'Contado (1 Pago)', value: 'CONTADO' },
  { label: 'Fraccionado (12 Pagos)', value: 'FRACCIONADO_12' }
];

export const listaMetodoPago = [
  { label: 'Tarjeta de Crédito', value: 'TARJETA' },
  { label: 'Red de Pagos (Aquí Pago / Pago Express)', value: 'RED' },
  { label: 'Pago Móvil', value: 'MOVIL' }
];

export const relaciones = [
  { label: 'Padre/Madre', value: 'padre' },
  { label: 'Hijo/Hija', value: 'hijo' },
  { label: 'Hermano/Hermana', value: 'hermano' },
  { label: 'Cónyuge (Esposo/a)', value: 'conyuge' },
  { label: 'Otro', value: 'otro' }
];

export const relacionesAsegurados = [
  { label: 'Titular', value: 'titular' },
  { label: 'Cónyuge (Esposo/a)', value: 'conyuge' },
  { label: 'Hijo/a', value: 'hijo' }
];

export const rutasPorGrupo = {
  ADMIN: [
    '/panel',
    '/admin-aseguradora',
    '/admin-aseguradora-planes',
    '/admin-sucursal-planes',
    '/polizas',
    '/solicitudes',
    '/cotizaciones',
    '/crearcotizacion',
    '/sucursales',
    '/usuarios',
    '/productos',
    '/inspecciones',
    '/siniestros',
    '/denuncia-siniestro',
    '/promociones',
    '/proveedores',
    '/cobranzas',
    '/comisiones',
    '/admin-aseguradora-productos',
    '/admin-aseguradora-asignacion',
    '/admin-aseguradora-landing',
    '/admin-aseguradora-detener',
    '/jobs',
    '/autorizaciones',
    '/admin-config',
    '/admin-empresa',
    '/autorizacion-config-empresa',
    '/enlace-config-empresa',
    '/autorizacion-config-aseguradora',
    '/autorizacion-config-aseguradora-empresa',
    '/verificadores',
    '/autorizacion-configuracion',
    '/cotizacionamedida',
    '/organizacion',
    '/aseguradoraproducto/vigencia/config',
    '/aseguradoraproducto/cobertura',
    '/canal-config-empresa',
    '/core'
  ],
  ADMIN_EMPRESA: [
    '/panel',
    '/polizas',
    '/solicitudes',
    '/cotizaciones',
    '/crearcotizacion',
    '/sucursales',
    '/usuarios',
    '/productos',
    '/inspecciones',
    '/siniestros',
    '/denuncia-siniestro',
    '/cobranzas',
    '/comisiones',
    '/autorizaciones',
    '/verificadores',
    '/cotizacionamedida',
    '/organizacion'
  ],
  ADMIN_ASEGURADORA: [
    '/panel',
    '/polizas',
    '/solicitudes',
    '/cotizaciones',
    '/crearcotizacion',
    '/sucursales',
    '/usuarios',
    '/productos',
    '/inspecciones',
    '/siniestros',
    '/denuncia-siniestro',
    '/cobranzas',
    '/comisiones',
    '/autorizaciones',
    '/autorizacion-config-aseguradora',
    '/verificadores',
    '/cotizacionamedida',
    '/organizacion'
  ],
  ADMIN_SUCURSAL: [
    '/panel',
    '/polizas',
    '/solicitudes',
    '/cotizaciones',
    '/crearcotizacion',
    '/usuarios',
    '/productos',
    '/inspecciones',
    '/siniestros',
    '/denuncia-siniestro',
    '/cobranzas',
    '/autorizaciones',
    '/cotizacionamedida',
    '/organizacion'
  ],
  EJECUTIVO: [
    '/panel',
    '/polizas',
    '/solicitudes',
    '/cotizaciones',
    '/crearcotizacion',
    '/productos',
    '/inspecciones',
    '/siniestros',
    '/denuncia-siniestro',
    '/cobranzas',
    '/autorizaciones',
    '/cotizacionamedida'
  ],
  EJECUTIVO_ASEGURADORA: [
    '/panel',
    '/polizas',
    '/solicitudes',
    '/cotizaciones',
    '/crearcotizacion',
    '/productos',
    '/inspecciones',
    '/siniestros',
    '/denuncia-siniestro',
    '/cobranzas',
    '/autorizaciones',
    '/cotizacionamedida'
  ],
  INSPECTOR: ['/inspecciones'],
  CLIENTE: [
    '/panel',
    '/polizas',
    '/solicitudes',
    '/cotizaciones',
    '/productos',
    '/inspecciones',
    '/siniestros',
    '/denuncia-siniestro',
    '/cobranzas'
  ]
};

export const listaPathsSinMenu = [
  '/solicitar',
  '/siniestros/form',
  '/firmar',
  '/solicitudes-consulta',
  '/inspecciones/form/',
  '/inspecciones/ampliacion/cliente/',
  '/denuncia-siniestro/',
  '/inspecciones/edit/',
  '/regenerar-token'
];

const noEsCliente = (user) => user && user['cognito:groups'][0] !== 'CLIENTE';

export const puedeMostrarMenu = (path, user, userState) => {
  const noEstaLogueado =
    !user &&
    (userState === USER_STATES.loggingEnd ||
      userState === USER_STATES.notLogged);

  if (noEstaLogueado) {
    return false;
  }

  let puedeMostrar = !listaPathsSinMenu.some((item) => path.startsWith(item));

  if (puedeMostrar) {
    return puedeMostrar;
  }

  puedeMostrar = noEsCliente(user, userState);
  return puedeMostrar;
};

export const gruposSistema = {
  ADMIN: 'Admin General',
  ADMIN_EMPRESA: 'Admin Empresa',
  ADMIN_SUCURSAL: 'Admin Sucursal',
  EJECUTIVO: 'Ejecutivo Comercial',
  ADMIN_ASEGURADORA: 'Admin Aseguradora',
  EJECUTIVO_ASEGURADORA: 'Ejecutivo Comercial (Aseguradora)',
  INSPECTOR: 'Inspector',
  CLIENTE: 'Cliente'
};

export const gruposSistemaPorGrupo = {
  ADMIN: ['ADMIN_EMPRESA', 'ADMIN_ASEGURADORA'],
  ADMIN_EMPRESA: ['ADMIN_EMPRESA', 'ADMIN_SUCURSAL', 'EJECUTIVO', 'INSPECTOR'],
  ADMIN_ASEGURADORA: ['ADMIN_ASEGURADORA', 'EJECUTIVO_ASEGURADORA'],
  ADMIN_SUCURSAL: ['EJECUTIVO']
};

export const gruposAprobadoresPorTipo = {
  EMPRESA: ['ADMIN_EMPRESA', 'ADMIN_SUCURSAL', 'EJECUTIVO'],
  ASEGURADORA: ['ADMIN_ASEGURADORA', 'EJECUTIVO_ASEGURADORA']
};

export const estadosSolicitud = {
  PROCESANDO: 'Procesando',
  PENDIENTE: 'Pendiente',
  VERIFICAR: 'Verificar',
  FINALIZADO: 'Finalizado',
  RECHAZADO: 'Rechazado',
  ARCHIVADO: 'Archivado',
  REVISION: 'Revisión',
  AUTORIZACION: 'Autorización'
};

export const estadosCobranza = {
  PENDIENTE: 'Pendiente',
  PAGADO: 'Pagado',
  VENCIDO: 'Vencido',
  ANULADO: 'Anulado'
};

export const estadosComision = {
  PENDIENTE: 'Pendiente',
  ACOBRAR: 'A cobrar',
  COBRADO: 'Cobrado',
  ANULADO: 'Anulado'
};

export const estadosPoliza = {
  PENDIENTE: 'Pendiente',
  VIGENTE: 'Vigente',
  VENCIDO: 'Vencido',
  ANULADO: 'Anulado'
};

export const tiposSolicitud = {
  INDIVIDUAL: 'Individual',
  MASIVA: 'Masiva'
};

export const tiposAutorizacion = [
  { key: 'monto', tipo: 'Monto' },
  { key: 'descuento', tipo: 'Descuento' },
  { key: 'zona', tipo: 'Zona' },
  { key: 'retroactividad', tipo: 'Retroactividad' },
  { key: 'cuestionario', tipo: 'Cuestionario' },
  { key: 'montoitem', tipo: 'Monto Item' },
  { key: 'vehiculo', tipo: 'Vehículo' },
  { key: 'datos', tipo: 'Modificación' },
  { key: 'vigencia', tipo: 'Vigencia' },
  { key: 'cumulo', tipo: 'Cúmulo' },
  { key: 'plan', tipo: 'Plan' },
  { key: 'actividad', tipo: 'Actividad' }
];

export const getCarouselData = (planes) => {
  if (planes.length === 0) {
    return [];
  }
  const total = planes[0].sumas.length;
  const carouselData = [];
  for (let i = 0; i < total; i += 1) {
    carouselData.push(planes.map((item) => ({ ...item, suma: item.sumas[i] })));
  }
  return carouselData;
};

export const getMonto = (monto) => {
  switch (Number(monto)) {
    case 0:
      return 'Incluye';
    case -1:
      return 'Excluye';
    default:
      // return `${formatoMonedaGenerico(moneda, monto)}`;
      return monto.toString().includes('.') ? monto : Number(monto);
  }
};

export const getMontoCalculado = (item, plan = {}, mostrarMontoFijo) => {
  const { datosExtra, monto_total: montoTotal, moneda, montoAsegurado } = plan;
  if (`${item.monto}` === '-1') {
    return 'Excluye';
  }
  if (item.subcobertura.opcion === 'monto_fijo') {
    return mostrarMontoFijo
      ? `${item.subcobertura.monto || '0'}` // 'd'
      : 'Incluye';
  }
  if (item.subcobertura.opcion === 'suma_tabla_ovp') {
    // return `${item.monto || '0'}`; // 'd'
    const monto =
      item.monto === -3 || item.monto === '-3'
        ? item.monto
        : formatoMonedaGenerico(moneda, item.monto || '0');

    return monto;
  }
  if (item.subcobertura.opcion === 'suma_tabla_rc') {
    // return `${item.monto || '0'}`; // 'd'
    const monto =
      item.monto === -3 || item.monto === '-3'
        ? item.monto
        : formatoMonedaGenerico(moneda, item.monto || '0');

    return monto;
  }
  if (item.subcobertura.opcion === 'porcentaje_capital') {
    return `${item.subcobertura.criterio}%`;
  }

  if (item.subcobertura.opcion === 'valor_capital') {
    let montoCabecera = Number(montoTotal);
    if (!montoCabecera && datosExtra) {
      montoCabecera = datosExtra.sumaAsegurada;
    } else if (montoAsegurado) {
      montoCabecera = montoAsegurado;
    }
    const suma = Number(item.monto);
    if (item.monto === undefined || item.monto === '' || item.monto === null) {
      return formatoMonedaGenerico(moneda, montoCabecera);
    }

    if (suma === 0) {
      return formatoMonedaGenerico(moneda, montoCabecera);
    }
    const monto =
      item.monto === -3 || suma === -3
        ? item.monto
        : formatoMonedaGenerico(moneda, item.monto);
    return monto;
  }

  return ``;
};

export const getFechaVigencia = (fechaDesde, codigo) => {
  switch (codigo) {
    case 'semanal':
      return fechaDesde.add(7, 'd');
    case 'mensual':
      return fechaDesde.add(1, 'M');
    case 'semestral':
      return fechaDesde.add(6, 'M');
    case 'trimestral':
      return fechaDesde.add(3, 'M');
    case 'anual':
      return fechaDesde.add(1, 'Y');
    default:
      return fechaDesde;
  }
};

export const getTableOpcionesPago = (
  planes,
  disableHeader,
  opcionesDePago,
  moneda,
  infoMoneda
) => {
  const data = [];
  if (!disableHeader) {
    const info = {
      detalle: `Opciones de pago ${
        infoMoneda && moneda ? `en ${moneda.simbolo}` : ''
      }`,
      opcion: true,
      sumas: planes.map((item) => item.titulo),
      items: planes.map((item) => ({ id_plan: item.id, estado: item.estado }))
    };
    data.push(info);
  }

  const algunFraccionado = planes.some(
    (item) => Number(item.fraccionado12) !== 0
  );

  if (opcionesDePago && opcionesDePago.numeroCuotas > 1 && algunFraccionado) {
    const info = {
      detalle: `Fraccionado`,
      opcion: true,
      footer: false,
      sumas: planes.map((item) => {
        if (Number(item.fraccionado12) === 0) {
          return 'No disponible';
        }
        return (
          <div>
            <span>{`(${item.numeroCuotas} x ${formatoMonedaGenerico(
              moneda,
              item.inicial
            )})`}</span>
            <br />
            <span>{`${formatoMonedaGenerico(
              moneda,
              item.fraccionado12
            )}`}</span>
          </div>
        );
      }),
      items: planes.map((item) => ({ id_plan: item.id }))
    };

    data.push(info);
  }

  const algunContado = planes.some((item) => Number(item.contado) !== 0);

  if (algunContado) {
    const info = {
      detalle: `Contado`,
      opcion: true,
      footer: false,
      sumas: planes.map((item) => {
        if (Number(item.contado) === 0) {
          return 'No disponible';
        }
        return `${formatoMonedaGenerico(moneda, item.contado)}`;
      })
    };
    data.push(info);
  }

  return data;
};

export const transformFranquiciaData = (item) => {
  return {
    franquicia_desde: item.desde,
    franquicia_hasta: item.hasta,
    franquicia_opcion: item.opcion,
    franquicia_monto: item.monto,
    franquicia_criterio: item.criterio,
    franquicia_descripcion: item.descripcion,
    franquicia_costo_min: item.costo_min,
    franquicia_costo_max: item.costo_max
  };
};

export const getDescripcionFranquicia = (item, moneda) => {
  let descripcion = ``;
  if (!item || !item.franquicia_opcion) {
    return '';
  }
  if (
    item.franquicia_opcion === 'suma_asegurada' ||
    item.franquicia_opcion === 'valor_siniestro'
  ) {
    if (item.franquicia_opcion === 'suma_asegurada') {
      descripcion = `${item.franquicia_criterio || '0'}% de la Suma Asegurada`;
    } else if (item.franquicia_opcion === 'valor_siniestro') {
      descripcion = `${item.franquicia_criterio || '0'}% del Siniestro`;
    }
    if (item.franquicia_costo_min && item.franquicia_costo_max) {
      descripcion += `, mínimo ${formatoMonedaGenerico(
        moneda,
        item.franquicia_costo_min
      )} y máximo ${formatoMonedaGenerico(moneda, item.franquicia_costo_max)}`;
    } else if (item.franquicia_costo_min) {
      descripcion += `, mínimo ${formatoMonedaGenerico(
        moneda,
        item.franquicia_costo_min
      )}`;
    } else if (item.franquicia_costo_max) {
      descripcion += `, máximo ${formatoMonedaGenerico(
        moneda,
        item.franquicia_costo_max
      )}`;
    }
  }
  if (item.franquicia_opcion === 'monto_fijo') {
    descripcion = `${formatoMonedaGenerico(
      moneda,
      item.franquicia_monto || '0'
    )} por Siniestro`;
  }

  if (item.franquicia_desde && item.franquicia_hasta) {
    if (
      item.franquicia_desde === item.franquicia_hasta &&
      item.franquicia_hasta === '1'
    ) {
      return descripcion;
    }
    return `${item.franquicia_desde}º al ${item.franquicia_hasta}º siniestro ${descripcion}`;
  }
  if (item.franquicia_desde) {
    return `A partir del ${item.franquicia_desde}º siniestro ${descripcion}`;
  }
  if (item.franquicia_hasta) {
    return `Del 1º al ${item.franquicia_hasta}º siniestro ${descripcion}`;
  }
  return descripcion;
};

export const getTableFranquicias = (planes, moneda) => {
  const cantidadItemColumnas = planes.length;
  const cantidadItemFilas = planes[0].planSubcobertura
    ? planes[0].planSubcobertura.length
    : 0;

  const planesDetail = [];
  for (let i = 0; i < cantidadItemFilas; i += 1) {
    const key = `${planes[0].planSubcobertura[i].orden}_franquicia`;
    const detalle = `Franquicia de ${planes[0].planSubcobertura[i].subcobertura?.cobertura.descripcion}`;
    const sumas = [];
    const items = [];
    for (let j = 0; j < cantidadItemColumnas; j += 1) {
      const item = planes[j].planSubcobertura[i];
      items.push(item);
      sumas.push(getDescripcionFranquicia(item, moneda));
    }
    // Solo si hay alguno que tenga franquicia
    if (sumas.some((suma) => suma)) {
      // Si tiene franquicia y la descripcion esta vacia se muestra el label Sin Franquicia
      // const sumasDescripcion = sumas.map((desc) => desc || 'Sin Franquicia');

      const sumasDescripcion = sumas.map((desc, index) => {
        if (items[index]?.monto === -1) {
          return 'No Aplica';
        }
        return desc || 'Sin Franquicia';
      });

      planesDetail.push({
        key,
        detalle,
        sumas: sumasDescripcion,
        franquicia: true,
        items
      });
    }
  }
  return planesDetail;
};

const getTableFranquiciaGeneral = (planes, moneda, controlFranquicias) => {
  const cantidadItemColumnas = planes.length;
  // Encontrar plan con más franquicias
  const planConMasFranquicias = planes.reduce((anterior, actual) => {
    // Verificar si anterior es undefined
    if (anterior === undefined) {
      return actual;
    }

    // Comparar la longitud de franquicias
    return (anterior.franquicias?.length || 0) >
      (actual.franquicias?.length || 0)
      ? anterior
      : actual;
  }, undefined); // Inicializa el acumulador como undefined
  // Cantidad de filas
  let cantidadFranquicias = planConMasFranquicias.franquicias?.filter(
    (e) => !e.eliminado
  ).length;
  const planesDetail = [];

  const sumas = [];
  let key;
  let detalle;
  const plan = [];
  let incluye = false;

  for (let i = 0; i < cantidadFranquicias; i += 1) {
    const descripcion = [];
    for (let j = 0; j < cantidadItemColumnas; j += 1) {
      key = `${planes[j].orden}_franquicia_${i}`;
      detalle = `Franquicia/Deducible General`;

      plan.push(planes[j]);

      // Es una franquicia general por plan
      const control = controlFranquicias?.find(
        (e) => e.id_aseguradora === planes[j].aseguradoraProducto.id_aseguradora
      );
      if (control && Object.keys(control).length > 0) {
        if (control.franquicias[i]) {
          cantidadFranquicias = control.franquicias[i].length;
          const descripcionControl = control.franquicias[i].descripcion;
          descripcion.push(descripcionControl);
          incluye = true;
        }
      } else {
        const descripcionPlan = planes[j].franquicias[i]
          ? getDescripcionFranquicia(
              transformFranquiciaData(planes[j].franquicias[i]),
              moneda
            )
          : undefined;
        descripcion.push(descripcionPlan);
      }
    }
    sumas.push(descripcion);
  }

  // Solo si hay alguno que tenga franquicia
  if (sumas.some((suma) => suma)) {
    // Si tiene franquicia y la descripcion esta vacia se muestra el label Sin Franquicia
    // const sumasDescripcion = sumas.map((desc) => desc || 'Sin Franquicia');

    // const sumasDescripcion = [];
    // for (let i = 0; i < cantidadItemColumnas; i += 1) {
    //   sumasDescripcion.push(
    //     sumas[i].map((desc, index) => {
    //       if (
    //         planes[i].franquicias &&
    //         planes[i].franquicias[index]?.monto === -1
    //       ) {
    //         return 'No Aplica';
    //       }
    //       return desc || 'Sin Franquicia';
    //     })
    //   );
    // }

    // Las filas son franquicias y las columnas planes
    // Ej: sumas[1][0] sería la 2da franquicia del 1er plan
    const sumasDescripcion = sumas.map((subArray, index) => {
      // Inicializar la descripción para este subarreglo
      let descripcion = '';

      return subArray.map((desc, i) => {
        // Si no hay un plan correspondiente o el monto del plan es -1, establecer la descripción como 'No Aplica'
        const p = planes[i];
        if (
          p.franquicias &&
          p.franquicias.length + 1 >= index &&
          p.franquicias[index]?.franquicia_monto === -1
        ) {
          descripcion = 'No Aplica';
        } else {
          // Si hay un plan válido, establecer la descripción como la descripción del plan
          descripcion = desc || 'Sin Franquicia';
        }

        return descripcion;
      });
    });

    sumasDescripcion.forEach((item) => {
      planesDetail.push({
        key,
        detalle,
        sumas: item,
        franquicia_general: true,
        incluye,
        plan
      });
    });
  }
  return planesDetail;
};

// devuelve la tabla final (planesDetail) que contiene información detallada sobre los planes, subcoberturas, sumas aseguradas, opciones, exclusiones y reemplazos.
export const getTable = (
  planes,
  incluyeConyuge,
  incluyeHijos,
  producto,
  mostrarTipo,
  mantenerExcluidos,
  tituloAdicional,
  mostrarMontoFijo,
  moneda,
  coberturasParaExcluir,
  controlFranquicias
) => {
  if (planes.length === 0) {
    return [];
  }

  let exclusion = false;
  let reemplazo = false;
  let anterior = {};

  const cantidadItemFilas = planes[0].planSubcobertura
    ? planes[0].planSubcobertura.length
    : 0;
  const cantidadItemColumnas = planes.length;
  // console.log('cantidadItemFilas', cantidadItemFilas);
  let planesDetail = [];
  planesDetail.push({
    key: `0`,
    detalle: `${tituloAdicional || 'Detalle de Cobertura'}`,
    sumas: planes.map((item) => item.titulo),
    items: planes.map(({ id, estado }) => ({ id_plan: id, estado })),
    moneda
  });
  let lastGroup = '';

  for (let i = 0; i < cantidadItemFilas; i += 1) {
    const key = `${planes[0].planSubcobertura[i].orden}`;
    const { id } =
      planes[0].planSubcobertura[i]?.subcobertura?.cobertura ||
      planes[0].planSubcobertura[i]?.cobertura;
    let detalle =
      planes[0].planSubcobertura[i].subcobertura?.cobertura?.descripcion ||
      planes[0].planSubcobertura[i].cobertura?.descripcion;
    const sumas = [];
    const items = [];
    const opciones = [];
    let rowCoberturaExcluye = true;

    for (let j = 0; j < cantidadItemColumnas; j += 1) {
      exclusion = false;
      reemplazo = false;
      const item = planes[j].planSubcobertura[i];
      item.editable = !planes[j].producto_cerrado;
      items.push(planes[j].planSubcobertura[i]);
      if (planes[j]?.planSubcoberturaOpcion)
        opciones.push(...planes[j]?.planSubcoberturaOpcion);

      const montoPlanCoberturaItem = Number(item.monto);

      const controlEncontrado = coberturasParaExcluir?.find(
        (e) =>
          e.controlProductoCobertura.id_subcobertura === item.id_subcobertura &&
          e.id_aseguradora === planes[j].aseguradoraProducto.id_aseguradora
      );

      if (controlEncontrado)
        if (
          controlEncontrado?.controlProductoCobertura?.id_subcobertura_reemplazo
        ) {
          reemplazo = true;
          anterior = controlEncontrado.controlProductoCobertura.subcobertura; // cobertura anterior
          item.subcobertura = controlEncontrado.controlProductoCobertura.subcR;
          detalle =
            controlEncontrado.controlProductoCobertura.subcR.cobertura
              .descripcion;
        } else if (
          !controlEncontrado?.controlProductoCobertura
            ?.id_subcobertura_reemplazo
        ) {
          exclusion = true;
        }
      if (montoPlanCoberturaItem !== -1) {
        rowCoberturaExcluye = false;
      }
      sumas.push(
        item.subcobertura
          ? getMontoCalculado(item, planes[j], mostrarMontoFijo, moneda)
          : 0
      );
      // Se elimina la condición porque, tras revisar la aplicación del título "Franquicias / Deducibles", no encontramos justificación para mantener esta condición. Podría provocar errores inesperados (bugs).

      // if (!(item.subcobertura?.cobertura?.grupo || item.cobertura?.grupo)) {
      //   descripcion = 'Franquicias / Deducibles';
      // } else {
      const descripcion =
        item.subcobertura?.cobertura?.grupo?.desc ||
        item.subcobertura?.cobertura?.grupo?.descripcion ||
        item?.cobertura?.grupo.descripcion;
      // }
      if (lastGroup !== descripcion) {
        lastGroup = descripcion;
        planesDetail.push({
          key: `${key}_grupo`,
          detalle: lastGroup,
          full: true,
          sumas: Array.from(Array(cantidadItemColumnas).keys()),
          items: planes.map((plan) => ({
            id_plan: plan.id,
            estado: plan.estado
          })),
          exclusion
        });
      }
    }

    if (!rowCoberturaExcluye || mantenerExcluidos) {
      planesDetail.push({
        key,
        detalle,
        sumas,
        id,
        items,
        opciones,
        exclusion,
        reemplazo,
        anterior
      });
    }
  }

  const franquicias = getTableFranquicias(planes, moneda);
  const franquiciaGeneral = getTableFranquiciaGeneral(
    planes,
    moneda,
    controlFranquicias
  );

  if (franquicias.length > 0 || franquiciaGeneral.length > 0) {
    planesDetail.push({
      key: `grupo_franquicias`,
      detalle: 'Franquicias / Deducibles',
      full: true,
      sumas: Array.from(Array(cantidadItemColumnas).keys())
    });
    planesDetail = [...planesDetail, ...franquicias, ...franquiciaGeneral];
  }
  return planesDetail;
};

export const getCoberturasLandingTable = ({ coberturasLanding }) => {
  if (coberturasLanding.length === 0) {
    return [];
  }
  const cantidadItemFilas = coberturasLanding.length;
  const planesDetail = [];
  planesDetail.push({
    key: `0`,
    detalle: 'Detalle de Cobertura',
    sumas: [`Sumas Aseguradas`],
    footer: false
  });

  for (let i = 0; i < cantidadItemFilas; i += 1) {
    const key = `${coberturasLanding[i].orden}`;
    const detalle = `${coberturasLanding[i].cobertura?.descripcion}`;
    const sumas = [];
    const items = [];
    const { id } = coberturasLanding[i].cobertura;
    sumas.push(getMonto(coberturasLanding[i].monto));
    items.push(coberturasLanding[i]);
    planesDetail.push({ key, detalle, sumas, items, id });
  }
  return planesDetail;
};

const checkCelularFormat = (celular) => {
  if (celular[0] === '+') {
    return parseCelular(celular);
  }
  return celular;
};

const getValoresRespaldo = (valorPrimario, valorRespaldoSecundario) => {
  if (valorPrimario) {
    return `${valorPrimario}`;
  }
  if (valorRespaldoSecundario) {
    return `${valorRespaldoSecundario}`;
  }
  return undefined;
};

export const transformarPropiedades = (fields) => {
  return {
    id: fields.id,
    cedula: fields.cedula,
    nombres: fields.nombres,
    celular: checkCelularFormat(fields.celular),
    correo: fields.correo,
    domicilio: fields.domicilio,
    departamento: fields.id_departamento
      ? `${fields.id_departamento}`
      : undefined,
    distrito: fields.id_distrito ? `${fields.id_distrito}` : undefined,
    nacionalidad: fields.nacionalidad,
    sexo: fields.sexo,
    estadoCivil: fields.estado_civil,
    lugarNacimiento: fields.lugar_nacimiento,
    ...(fields.fecha_nacimiento !== null &&
      fields.fecha_nacimiento !== undefined && {
        fechaNacimiento: moment(fields.fecha_nacimiento, 'YYYY-MM-DD')
      }),
    ruc: fields.ruc,
    profesion: fields.profesion,
    ingresos: getCodigoIngreso(fields.ingresos),
    proveedorEstado: fields.proveedor_estado === 'Sí',
    politicamenteExpuesto: fields.expuesta_politicamente === 'Sí',
    trabajo: fields.tipo_empleado,
    institucion: fields.institucion_publica,
    cargo: fields.institucion_cargo,
    anioIngreso: fields.institucion_anhoingreso,
    rucEmpleador:
      fields.empleador_ruc === 'A Confirmar' ? '' : fields.empleador_ruc,
    empresaEmpleador: fields.empleador_empresa,
    telefonoEmpleador:
      fields.empleador_telefono === 'A Confirmar'
        ? ''
        : fields.empleador_telefono,
    celularEmpleador: fields.empleador_celular
      ? parseCelular(fields.empleador_celular)
      : '',
    direccionEmpleador: fields.empleador_direccion
      ? fields.empleador_direccion
      : '',
    tercero: {
      nombres: fields.tercero ? fields.tercero.nombres : fields.nombres,
      ruc: fields.tercero ? fields.tercero.ruc : '',
      celular: fields.tercero ? fields.tercero.celular : '',
      domicilio: fields.tercero ? fields.tercero.domicilio : fields.domicilio,
      correo: fields.tercero ? fields.tercero.correo : fields.correo,
      id_departamento: getValoresRespaldo(
        fields.tercero?.id_departamento,
        fields.id_departamento
      ),
      id_distrito: getValoresRespaldo(
        fields.tercero?.id_distrito,
        fields.id_distrito
      )
    }
  };
};

export const getCodigoIngreso = (ingreso) => {
  switch (Number(ingreso)) {
    case 2000000:
      return '1';
    case 6000000:
      return '2';
    case 11000000:
      return '3';
    case 16000000:
      return '4';
    default:
      return '';
  }
};

export const verificarTitular = (titularSeguro, titularTarjeta) => {
  if (!titularSeguro && !titularTarjeta) {
    return true;
  }
  const palabrasTitularSeguro = titularSeguro.split(' ');
  const palabrasTitularTarjeta = titularTarjeta.split(' ');

  for (let i = 0; i < palabrasTitularSeguro.length; i += 1) {
    for (let j = 0; j < palabrasTitularTarjeta.length; j += 1) {
      // Pone todo en minuscula y borra cualquier caracter que no sea numero ni letra
      // Ej.: "Benitez," --> benitez
      const palabraSeguro = palabrasTitularSeguro[i]
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+/g, '');
      const palabraTarjeta = palabrasTitularTarjeta[j]
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+/g, '');
      if (palabraSeguro && palabraTarjeta && palabraSeguro === palabraTarjeta) {
        return true;
      }
    }
  }
  return false;
};

export const convertToCSV = (objArray) => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  let str = '';

  for (let i = 0; i < array.length; i += 1) {
    let line = '';
    // eslint-disable-next-line guard-for-in
    for (const index in array[i]) {
      // eslint-disable-next-line eqeqeq
      if (line != '') line += ',';

      line += array[i][index];
    }

    str += `${line}\r\n`;
  }

  return str;
};

export const exportCSVFile = (headers, items, fileTitle) => {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  const jsonObject = JSON.stringify(items);
  const csv = convertToCSV(jsonObject);

  const exportedFilenmae = `${fileTitle}.csv` || 'export.csv';

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export const toUpperCase = (str) => {
  return str.toUpperCase();
};

export const validarCaracterTelefono = (e) => {
  const specialCharRegex = new RegExp(
    /[a-zA-Z&\\/\\¡!@#+=()$~%^°":.,*¿?<>{}]/g
  );
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (specialCharRegex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
  return true;
};

export const validarCaracterEspecial = (e, pressedKey) => {
  const specialCharRegex = new RegExp(/[&\\/\\¡!@#+=()$~%^°":*¿?<>{}]/g);

  if (specialCharRegex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
  return true;
};

export const isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
  navigator.userAgent
);

export const getCoordenadasByDireccion = async (direccion) => {
  const apiKey = CONFIG.GOOGLE_MAPS_KEY;
  Geocode.setApiKey(apiKey);
  Geocode.setRegion('py');
  let coordenadas = { lat: {}, lng: {} };
  try {
    const response = await Geocode.fromAddress(direccion);
    const { results } = response;
    const streetAddress = results.filter((geo) => {
      return (
        (geo.types[0] === 'street_address' ||
          geo.types[0] === 'route' ||
          geo.types[0] === 'intersection' ||
          geo.types[0] === 'locality' ||
          geo.types[1] === 'political') &&
        geo.address_components.find((address) => address.short_name === 'PY')
      );
    });

    coordenadas =
      streetAddress.length > 0 ? streetAddress[0].geometry.location : null;
    return coordenadas;
  } catch (error) {
    return null;
  }
};

export const getDireccionByCoordenadas = async (coordenadas) => {
  const apiKey = CONFIG.GOOGLE_MAPS_KEY;
  Geocode.setApiKey(apiKey);
  Geocode.setRegion('py');
  let direccion = '';
  await Geocode.fromLatLng(coordenadas.lat, coordenadas.lng).then(
    (response) => {
      const { results } = response;
      const streetAddress = results.filter((geo) => {
        return geo.types[0] === 'street_address' || geo.types[0] === 'route';
      });
      direccion =
        streetAddress.length > 0 ? streetAddress[0].formatted_address : null;

      return direccion;
    },
    () => {
      return null;
    }
  );
  return direccion;
};

export const getDatosBCP = async (tipoDoc, documento, aseguradora) => {
  try {
    const response = await instanceRef.instance.get(`/poliza/datosbcp`, {
      params: { tipoDoc, documento, aseguradoraId: aseguradora.id }
    });
    const datosBCP = response.data;
    // Ver si se debe generar error

    return datosBCP;
  } catch (error) {
    return null;
  }
};

export const getDatosVehiculoBCP = async (chapa, aseguradora) => {
  try {
    const response = await instanceRef.instance.get(
      `/poliza/datosvehiculobcp`,
      {
        params: { chapa, aseguradoraId: aseguradora.id }
      }
    );
    const datosBCP = response.data;
    // Ver si se debe generar error

    return datosBCP;
  } catch (error) {
    return null;
  }
};

// =============================================================================
// CALCULO DE DIGITO VERIFICADOR SEGUN SET en JS
// =============================================================================
// const digitoVerificador = calcularDigitoVerificador('4876968');

export const calcularDigitoVerificador = (paramNumero, paramBasemax = 11) => {
  const numero = String(paramNumero);
  const basemax = Number(paramBasemax);
  let total = 0;
  let resto = 0;
  let k = 0;
  let numeroAux = 0;
  let digit = 0;
  let numeroAl = '';
  for (let i = 0; i < numero.length; i += 1) {
    const c = Number(numero.charAt(i));
    numeroAl += c.toString();
  }
  k = 2;
  total = 0;
  for (let i = numeroAl.length - 1; i >= 0; i -= 1) {
    if (k > basemax) {
      k = 2;
    }
    numeroAux = Number(numeroAl.charAt(i));
    total += numeroAux * k;
    k += 1;
  }
  resto = total % 11;
  if (resto > 1) {
    digit = 11 - resto;
  } else {
    digit = 0;
  }
  return digit;
};

export const renderPorcentaje = (value) =>
  value ? <span style={{ whiteSpace: 'nowrap' }}>{`${value} %`}</span> : '';

export const getDatosSetByRuc = async (ruc) => {
  try {
    const response = await instanceRef.instance.get(`/solicitud/ruc/${ruc}`);
    if (response.data && response.data.data) {
      const datos = response.data.data.datos ? response.data.data.datos : null;
      return datos;
    }

    return null;
  } catch (error) {
    return error;
  }
};

export const consultarCliente = async (idAseguradora, cedula, idCotizacion) => {
  try {
    const response = await instanceRef.instance.post(
      `/sebaot/consultar-cliente`,
      {
        idAseguradora,
        cedula,
        idCotizacion
      }
    );
    const datos = response.data.data;
    return datos;
  } catch (error) {
    return error;
  }
};

export const myImageCompression = async (file, compressionOptions) => {
  if (
    file.type.split('/')[1] === 'heic' ||
    file.type.split('/')[1] === 'heif'
  ) {
    return file;
  }
  return imageCompression(file, compressionOptions);
};

export const heicAndheifConvert = async (file) => {
  if (
    file.type.split('/')[1] === 'heic' ||
    file.type.split('/')[1] === 'heif'
  ) {
    const imageConvert = new Promise((resolve) => {
      heic2any({ blob: file, toType: 'image/jpeg' }).then((imageUrl) =>
        resolve(imageUrl)
      );
    });
    const converted = await imageConvert;
    return converted;
  }
  return file;
};

export const getAppHostDomain = (app_host) => {
  return app_host.replace(/-.*?\./, '.');
};

export const isNumber = (input) => RegExp(/\d/, 'gi').test(input);

export const getCurrencyInputConfig = (moneda) => {
  if (moneda.codigo === 'gs') {
    return {
      decimalsLimit: 0,
      decimalSeparator: ',',
      groupSeparator: '.'
    };
  }
  if (moneda.codigo === 'usd') {
    return {
      decimalsLimit: 2,
      decimalSeparator: '.',
      groupSeparator: ','
    };
  }
  return {};
};

/**
 * Convierte una cadena con formato de moneda a Number
 * @param {string} value Valor a ser convertido. Ej.: '1,000.50'
 * @param {moneda} moneda Moneda. Ej.: { codigo: 'usd', descripcion: 'Dolar Estadounidense'}
 * @returns 1000.5
 */
export const currencyToNumber = (value, moneda) => {
  const config = getCurrencyInputConfig(moneda);
  const sinAgrupar = `${value}`.replaceAll(config.groupSeparator, '');
  return Number(sinAgrupar.replaceAll(config.decimalSeparator, '.'));
};

/**
 * Convierte una cadena con formato de moneda a Number
 * @param {string} value Valor a ser convertido. Ej.: '1,000.50'
 * @param {moneda} moneda Moneda. Ej.: { codigo: 'usd', descripcion: 'Dolar Estadounidense'}
 * @returns 1000.5
 */
export const numberToCurrency = (value, moneda) => {
  const config = getCurrencyInputConfig(moneda);
  return formatValue({ value: `${value}`, ...config });
};

export const formatNumberOnKeyPress = (e) => {
  const number = new RegExp(/[0-9]/g);
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!number.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
  return true;
};

export const convertMomentToListFormat = (fechaMoment) => {
  return moment([
    fechaMoment.get('years'),
    fechaMoment.get('months'),
    fechaMoment.get('days')
  ]);
};

export const ordenarVigencias = (vigencias, field) => {
  const ordenamiento = {
    semanal: 1,
    mensual: 2,
    bimestral: 3,
    trimestral: 4,
    semestral: 5,
    anual: 6,
    multi_anual: 7,
    personalizado: 8
  };
  const vigenciasOrdenadas = vigencias.sort((a, b) => {
    const ordenA = field
      ? ordenamiento[a[field].codigo]
      : ordenamiento[a.codigo];
    const ordenB = field
      ? ordenamiento[b[field].codigo]
      : ordenamiento[b.codigo];
    return ordenA - ordenB;
  });
  return vigenciasOrdenadas;
};

export const ordenarFrecuencias = (frecuencias) => {
  const ordenamiento = {
    semanal: 1,
    mensual: 2,
    bimestral: 3,
    trimestral: 4,
    semestral: 5,
    anual: 6,
    multi_anual: 7,
    personalizado: 8,
    total: 9
  };
  if (frecuencias) {
    const frecuenciasOrdenadas = frecuencias.sort(
      (a, b) => ordenamiento[a.codigo] - ordenamiento[b.codigo]
    );
    return frecuenciasOrdenadas;
  }

  return frecuencias;
};

export const reconocerCombustible = (id, submodelos) => {
  const submodeloSelected = submodelos.find((item) => item.id === id);
  return submodeloSelected?.combustible;
};

export const getTipoValidacion = (tipo) => {
  if (tipo.id_departamento || tipo.id_distrito || tipo.poligono) {
    return 'zona';
  }
  return 'vehiculo';
};

export const hexToRgb = (hex) =>
  hex &&
  hex
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`
    )
    .substring(1)
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16));

export const getIcon = (codigo, props) => {
  switch (codigo) {
    case 1:
      return <CarOutlined {...props} />;
    case 2:
      return <UserOutlined {...props} />;
    case 3:
      return <HeartOutlined {...props} />;
    case 4:
      return <HomeOutlined {...props} />;
    case 5:
      return <ShopOutlined {...props} />;
    case 6:
      return <WalletOutlined {...props} />;
    case 8:
      return <GlobalOutlined {...props} />;
    default:
      return null;
  }
};

export const convertDateStringToFormat = (dateString) => {
  const parts = dateString.split('-');
  if (parts.length === 3) {
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];
    return `${day}/${month}/${year}`;
  }
  return dateString;
};

export const getTagColorByEstado = (estado, user) => {
  const isAdminAseguradora =
    user && user['cognito:groups'][0] === 'ADMIN_ASEGURADORA';

  if (isAdminAseguradora) {
    switch (estado) {
      case 'PENDIENTE':
        return 'yellow';
      case 'ANULADO':
        return 'red';
      case 'VIGENTE':
        return 'volcano';
      case 'DOCUMENTOS PENDIENTES':
        return 'orange';
      default:
        return 'green';
    }
  } else {
    switch (estado) {
      case 'PENDIENTE':
        return 'yellow';
      case 'ANULADO':
        return 'red';
      case 'DOCUMENTOS PENDIENTES':
        return 'orange';
      default:
        return 'green';
    }
  }
};

export const getDescripcionOpcion = (opcion) => {
  switch (opcion) {
    case 'valor_capital':
      return 'Valor capital';
    case 'porcentaje_capital':
      return 'Porcentaje capital';
    case 'monto_fijo':
      return 'Monto Fijo';
    case 'suma_tabla_rc':
      return 'Tabla RC';
    case 'suma_tabla_ovp':
      return 'Tabla OVP';
    default:
      return '';
  }
};

export const getCriterio = (data, moneda) => {
  switch (data.opcion) {
    case 'valor_capital':
      if (data.monto) {
        return `${formatoMonedaGenerico(moneda, data.monto)}`;
      }
      return `100%`;
    case 'porcentaje_capital':
      return `${data.criterio}%`;
    case 'monto_fijo':
      return `${formatoMonedaGenerico(moneda, data.monto)}`;
    case 'suma_tabla_rc':
      return '';
    case 'suma_tabla_ovp':
      return '';
    default:
      return '';
  }
};

export const filtrarListado = (inputValue, option) => {
  return option.label
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .includes(inputValue.toLowerCase());
};

export const uploadStyles = {
  height: '100%',
  width: '100%',
  objectFit: 'contain',
  borderRadius: 8
};

export const getDescripcionDocumento = (descripcion) => {
  switch (descripcion) {
    case 'FormularioUnico.pdf':
      return 'Formulario Único';
    case 'Declaracion.pdf':
      return 'Declaración';
    case 'Propuesta.pdf':
      return 'Propuesta';
    case 'Formulario.pdf':
      return 'Formulario';
    default:
      return '';
  }
};

export const scrollToRef = (ref) => {
  if (ref && ref.current) {
    const headerOffset = 64;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = ref.current.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - headerOffset;

    ref.current.scrollIntoView({
      top: offsetPosition,
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
};
